<template>
  <div>
    <v-data-table
      style="border: 1.2px solid #c9c9c9; border-radius: 10px"
      :headers="headersActive"
      :expand="expand"
      :items="baseDistanceList"
      :isLoading="isLoading"
      ref="dTable"
      item-key="distance_id"
      hide-actions
    >
      <template v-slot:items="props">
        <tr>
          <td @click="props.expanded = !props.expanded">
            {{ baseDistanceList.indexOf(props.item) + 1 }}
          </td>
          <td v-if="isStatus">
            <v-switch
              color="primary"
              v-model="props.item.distance_status"
              hide-details
              @change="changeStatus(props.item)"
            ></v-switch>
          </td>
          <td class="text-xs-center" @click="props.expanded = !props.expanded">
            {{
              moment(props.item.distance_time_start).format(
                "DD/MM/YYYY - HH:mm"
              )
            }}
          </td>
          <td @click="props.expanded = !props.expanded" class="text-xs-center">
            {{
              props.item.distance_time_end == null
                ? "Present"
                : moment(props.item.distance_time_end).format(
                    "DD/MM/YYYY - HH:mm"
                  )
            }}
          </td>
          <td
            class="text-xs-center"
            v-if="props.item.distance_category == 1"
            @click="props.expanded = !props.expanded"
          >
            All
          </td>
          <td
            class="text-xs-center"
            v-else-if="props.item.distance_category == 2"
            @click="props.expanded = !props.expanded"
          >
            <div v-if="loadingDistrict == true">
              <v-progress-circular
                :size="22"
                color="primary"
                indeterminate
              ></v-progress-circular>
            </div>
            <ul v-else>
              <li
                v-for="(districtID, i) in props.item.distance_district"
                :key="i"
              >
                {{ showDistrict(districtID) }}
              </li>
            </ul>
          </td>
          <td v-else></td>
          <td
            class="text-xs-center"
            v-if="props.item.distance_store.length == 0"
            @click="props.expanded = !props.expanded"
          >
            All
          </td>
          <td class="text-xs-center" v-else>
            <div
              v-if="isLoadingStoreList == true"
              @click="props.expanded = !props.expanded"
            >
              <v-progress-circular
                :size="22"
                color="primary"
                indeterminate
              ></v-progress-circular>
            </div>
            <ul v-else>
              <li
                @click="props.expanded = !props.expanded"
                v-for="(storeID, i) in props.item.distance_store.slice(0, 3)"
                :key="i"
              >
                {{ showStore(storeID) }}
              </li>
            </ul>
            <v-btn
              v-if="props.item.distance_store.length > 3"
              flat
              color="info"
              style="text-decoration: underline"
              small
              @click="toSeeMoreStore(props.item.distance_store)"
              >see more</v-btn
            >
          </td>
          <!-- distance_category == 1 All , distance_category == 2 district ,distance_category == 3 store -->

          <td class="text-xs-center" v-if="isAction">
            <v-btn
              :loading="isEditDistance.includes(props.item.distance_id)"
              icon
              @click="$emit('toEdit', { item: props.item, index: props.index })"
              ><v-icon>edit</v-icon></v-btn
            >
            <!-- <v-btn
              :disabled="isEditDistance.includes(props.item.distance_id)"
              icon
              @click="
                $emit('toDelete', { item: props.item, index: props.index })
              "
              ><v-icon>delete</v-icon></v-btn
            > -->
          </td>
        </tr>
      </template>
      <template v-slot:expand="props">
        <v-divider></v-divider>
        <v-card flat>
          <v-card-text>
            <div
              v-for="(info, index) in props.item.distance_text"
              :key="index"
              class="pt-1"
              style="display: flex; align-items: center"
            >
              <v-avatar color="primary" size="30">
                <span class="black--text">{{ index + 1 }}</span>
              </v-avatar>
              <span class="ml-2"
                >from {{ info.transport_charge_start + " m." }} to
                {{ info.transport_charge_end + " m." }} --> Charge
                {{ info.transport_charge_price + " ฿" }}</span
              >
              <div v-if="fixedPrice">
                <div
                  style="
                    border-radius: 5px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    padding: 0px 10px;
                    background-color: red;
                    color: white;
                  "
                  class="ml-2"
                  v-if="info.is_fixed_price"
                >
                  Fixed price
                </div>
              </div>
            </div>
          </v-card-text>
        </v-card>
      </template>
    </v-data-table>
    <v-dialog v-model="moreStoreDialog" max-width="500px">
      <v-card v-if="isLoadingStoreList == false">
        <v-card-title
          ><h2>More Store</h2>
          <v-spacer></v-spacer>
          <v-btn icon @click="moreStoreDialog = false"
            ><v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <div class="px-3">
          <v-text-field
            prepend-icon="search"
            v-model="searchStoreList"
            placeholder="Store name th"
          ></v-text-field>
        </div>

        <v-card-text>
          <v-data-table
            style="border: 1px solid grey"
            :headers="[
              {
                text: '#',
                align: 'left',
                sortable: false,
              },
              { text: 'Store name', align: 'center', sortable: false },
            ]"
            :items="filteredStoreList"
          >
            <template v-slot:items="props">
              <tr>
                <td>{{ moreStoreList.indexOf(props.item) + 1 }}</td>
                <td class="text-xs-center">{{ props.item.store_name_th }}</td>
              </tr></template
            >
          </v-data-table></v-card-text
        >
      </v-card>
      <v-card color="primary" light v-else>
        <v-card-text style="color: grey">
          Please stand by
          <v-progress-linear
            indeterminate
            color="grey"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from "vuex";

export default {
  props: {
    fixedPrice: {
      type: Boolean,
      default() {
        return false;
      },
    },
    isAction: {
      type: Boolean,
      default() {
        return false;
      },
    },
    isDistrict: {
      type: Boolean,
      default() {
        return false;
      },
    },
    isStatus: {
      type: Boolean,
      default() {
        return false;
      },
    },
    headers: {},
    isLoading: {},
    baseDistanceList: {},
    isEditDistance: {
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      districtList: [],
      expand: true,
      loadingDistrict: false,
      moreStoreDialog: false,
      moreStoreList: [],
      isLoadingStoreList: false,
      searchStoreList: "",
    };
  },
  watch: {
    baseDistanceList() {
      for (let i = 0; i < this.baseDistanceList.length; i += 1) {
        const item = this.baseDistanceList[i];
        if (i == 0) {
          this.$set(this.$refs.dTable.expanded, item.distance_id, true);
        } else {
          this.$set(this.$refs.dTable.expanded, item.distance_id, false);
        }
      }
    },
  },
  computed: {
    ...mapGetters({ baseDistanceStore: "fetchStoreBack/baseDistanceStore" }),
    ...mapState({
      provinceData: (state) => state.fetchProvinceBack.provinceData,
    }),
    headersActive() {
      let headerList = [
        {
          text: "#",
          align: "left",
          sortable: false,
        },
        { text: "Status", align: "center", sortable: false },
        { text: "Time start", align: "center", sortable: false },
        { text: "Time end", align: "center", sortable: false },
        { text: "District", align: "center", sortable: false },
        { text: "Store", align: "center", sortable: false },
        { text: "Action", align: "center", sortable: false },
      ];
      return headerList.filter((val) => {
        let check = true;
        if (!this.isAction && val.text == "Action") {
          check = false;
        }

        if (!this.isDistrict && val.text == "District") {
          check = false;
        }

        if (!this.isStatus && val.text == "Status") {
          check = false;
        }

        return check;
      });
    },
    filteredStoreList() {
      return this.moreStoreList.filter((val) =>
        val.store_name_th
          .toLowerCase()
          .includes(this.searchStoreList.toLowerCase())
      );
    },
  },
  methods: {
    ...mapActions({
      getDistrictCore: "fetchProvinceBack/getDistrictCore",
      fetchStoreList: "fetchStoreBack/getStoreList",
    }),
    async getDistrictList() {
      let provinceItem = this.provinceData.find(
        (val) =>
          val.province_name_en.toLowerCase().replace(/ /g, "") ==
          this.$store.state.backOffice.province
      );

      if (!provinceItem) return;
      this.loadingDistrict = true;
      this.districtList = await this.getDistrictCore(provinceItem.province_id);
      this.$emit("onLoadDistrict", this.districtList);
      this.loadingDistrict = false;
    },
    showDistrict(district_id) {
      let districtItem = this.districtList.find(
        (val) => val.district_id == district_id
      );
      if (!districtItem) return "";
      return districtItem.district_name_th;
    },
    showStore(store_id) {
      let storeItem = this.baseDistanceStore.find(
        (val) => val.store_id == store_id
      );
      if (!storeItem) return "";
      return storeItem.store_name_th;
    },
    changeStatus(item) {
      console.log(item);
      this.$emit("toChangeStatus", {
        item: item,
        failed() {
          item.distance_status = !item.distance_status;
        },
      });
    },
    toSeeMoreStore(storeIDList) {
      this.moreStoreList = this.baseDistanceStore.filter((val) =>
        storeIDList.includes(val.store_id)
      );
      this.moreStoreDialog = true;
    },
    async getStoreList() {
      this.isLoadingStoreList = true;
      await this.fetchStoreList();
      this.isLoadingStoreList = false;
    },
  },
  created() {
    this.getDistrictList();
    this.getStoreList();
  },
};
</script>

<style scoped>
.spinner {
  width: 40px;
  height: 40px;
  background-color: #333;

  margin: 20px auto;
  -webkit-animation: sk-rotateplane 1.2s infinite ease-in-out;
  animation: sk-rotateplane 1.2s infinite ease-in-out;
}

@-webkit-keyframes sk-rotateplane {
  0% {
    -webkit-transform: perspective(120px);
  }
  50% {
    -webkit-transform: perspective(120px) rotateY(180deg);
  }
  100% {
    -webkit-transform: perspective(120px) rotateY(180deg) rotateX(180deg);
  }
}

@keyframes sk-rotateplane {
  0% {
    transform: perspective(120px) rotateX(0deg) rotateY(0deg);
    -webkit-transform: perspective(120px) rotateX(0deg) rotateY(0deg);
  }
  50% {
    transform: perspective(120px) rotateX(-180.1deg) rotateY(0deg);
    -webkit-transform: perspective(120px) rotateX(-180.1deg) rotateY(0deg);
  }
  100% {
    transform: perspective(120px) rotateX(-180deg) rotateY(-179.9deg);
    -webkit-transform: perspective(120px) rotateX(-180deg) rotateY(-179.9deg);
  }
}
</style>
